<template>
    <div class="event-stat">
        <div class="event-stat__head">
            <span class="event-stat__icon">{{ icon }}</span>
            <span class="event-stat__label">{{ label }}</span>
        </div>
        <div class="event-stat__value">{{ value }}</div>
        <div v-if="sub" class="event-stat__sub">{{ sub }}</div>
    </div>
</template>
<script>
export default {
    props: {
        icon: { type: String, default: '' },
        label: { type: String, required: true },
        value: { type: [String, Number], required: true },
        sub: { type: String, default: '' },
    },
}
</script>
<style lang="scss" scoped>
.event-stat {
    background: var(--color_white);
    border-radius: 24px;
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;

    &__head {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    &__icon {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: linear-gradient(180deg, #f8c7d8 0%, #d8c4fb 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
    }
    &__label {
        font-family: 'Lato';
        font-size: 14px;
        color: var(--font_color);
    }
    &__value {
        font-family: 'Inter';
        font-weight: 700;
        font-size: 28px;
        color: var(--font_deep_color);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    &__sub {
        font-family: 'Lato';
        font-size: 12px;
        color: var(--font_modif_color);
    }
}
</style>
